import React from 'react';
import AnnouncementBar from '../components/AnnouncementBar';
import Header from '../components/Header';
import UspStrip from '../components/UspStrip';
import HeroBanners from '../components/HeroBanners';
import CategoryGrid from '../components/CategoryGrid';
import ProductCarousel from '../components/ProductCarousel';
import BannerSection from '../components/BannerSection';
import FounderSection from '../components/FounderSection';
import Reviews from '../components/Reviews';
import InstagramSection from '../components/InstagramSection';
import Footer from '../components/Footer';
import CartDrawer from '../components/CartDrawer';
import { useCatalogue } from '../context/CatalogueContext';
import { sampleKitImage, specialOfferImage, collectionBannerImage } from '../mock';

export default function Home() {
  const { products } = useCatalogue();
  const forHim = products.filter(p => p.gender === 'MEN' || p.gender === 'UNISEX');
  const forHer = products.filter(p => p.gender === 'WOMEN' || p.gender === 'UNISEX');
  const founderReserve = products.filter(p =>
    ['rp-aventus', 'rf-rose-and-oud', 'rp-ombre-nomade', 'ep-dark-secret', 'rp-royal-white'].includes(p.id)
  );
  const newArrivals = [...products].reverse().slice(0, 8);
  const bundles = products.filter(p => p.rating >= 4.8);

  return (
    <div className="bg-[#F5EFE6] min-h-screen">
      <div className="sticky top-0 z-50">
        <AnnouncementBar />
        <Header embedded />
      </div>
      <UspStrip />
      <HeroBanners />
      <CategoryGrid />

      <ProductCarousel
        id="most-loved"
        eyebrow="The Signature Edit"
        title="Most Loved"
        subtitle="The scents our patrons return to, again and again."
        tabs={['Date Night', 'Office', 'Party']}
        products={products}
      />

      <BannerSection
        id="sample"
        eyebrow="Sample Kit"
        title="Try Before You Fall"
        subtitle="Discover four Rajpurohit scents in miniature — from just ₹99."
        image={sampleKitImage}
        ctaLabel="Build Your Kit"
        overlayText={{ eyebrow: 'From ₹99', title: 'The Discovery Set' }}
      />

      <ProductCarousel
        id="unisex"
        eyebrow="Curated By The Founder"
        title="The Founder's Reserve"
        subtitle="Five bottles chosen personally — my daily rotation."
        products={founderReserve}
      />

      <BannerSection
        eyebrow="Special Offer"
        title="Five 20ML Flacons · ₹1,999"
        subtitle="Mix and match your favourite Rajpurohit scents in a signature travel set."
        image={specialOfferImage}
        ctaLabel="Build Your Box"
      />

      <ProductCarousel
        id="bundles"
        eyebrow="Discovery & Bundles"
        title="Explore More For Less"
        subtitle="Save more when you journey through the house."
        products={bundles}
      />

      <ProductCarousel
        id="him"
        eyebrow="For Him"
        title="His Best Scent"
        subtitle="Bold. Considered. Unmistakable."
        tabs={['Date Night', 'Office', 'Party']}
        products={forHim}
      />

      <BannerSection
        id="shop"
        eyebrow="Discover"
        title="The Complete Collection"
        subtitle="Nine extraits — one house, endless expressions."
        image={collectionBannerImage}
        height="lg"
        overlayText={{ eyebrow: 'The House', title: 'Nine Bottles. One Story.' }}
      />

      <ProductCarousel
        id="her"
        eyebrow="For Her"
        title="Her Best Scent"
        subtitle="Elegance, in every note."
        tabs={['Date Night', 'Everyday', 'Party']}
        products={forHer}
      />

      <ProductCarousel
        id="new-arrivals"
        eyebrow="New Arrival"
        title="The Latest Additions"
        subtitle="Just released — freshly composed and freshly bottled."
        products={newArrivals}
      />

      <FounderSection />
      <Reviews />
      <InstagramSection />
      <Footer />
      <CartDrawer />
    </div>
  );
}
